import { useContext } from 'react'
import { SearchContext } from '../context/search'
export default function useSearch() {
	return useContext(SearchContext)
}
